function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { sortBy } from 'lodash';
import { Box, Button, Dialog, Flex, Markdown, MenuButton, useToasts } from '@applyboard/crystal-ui';
import { EditOutlineIcon, ChevronDownOutlineIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { useLegacyHandlers } from '@applyboard/ab-application-legacy';
import { ProgramType, useApplication, useApplicationAvailableActions, useApplicationMainProgram, useApplicationEslProgram, useFeatureFlags, useLegacyApplication, useIntakes, useSendApplicationAction } from "../../data";
import { ApplicationActionName, SimpleStatusApplicationAction } from "../../../../types";
import { assert } from "../../../../utils/assert";
import { IntakesForm } from "../IntakesForm";
import { ChangeIntakeModal } from "../ChangeIntakeModal";
import { ChangeProgramModal } from "../ChangeProgramModal";
import { ProcessDeferralModal } from "../ProcessDeferralModal";
import { RecommendedProgramsDialog } from "../RecommendedProgramsDialog";
import { RequestDeferralDialog } from "../RequestDeferralDialog";
import { RequestTuitionDepositRefundDialog } from "../RequestTuitionDepositRefundDialog";
import { useManageApplicationEventTracker } from "../../utils/eventTracking";
import { CancelWithdrawActionDialog } from "./CancelWithdrawActionDialog";
import { useHistory } from 'react-router-dom';
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var validStatusActions = [ApplicationActionName.COMPLETE_EVALUATION, ApplicationActionName.SUBMIT_TO_SCHOOL, ApplicationActionName.DECIDE_ACCEPTED, ApplicationActionName.DECIDE_REJECTED, ApplicationActionName.DECIDE_PROGRAM_CLOSED, ApplicationActionName.DECIDE_WAITLISTED, ApplicationActionName.COMPLETE_ADMISSION, ApplicationActionName.COMPLETE_VISA_STEPS, ApplicationActionName.CONFIRM_ENROLMENT, ApplicationActionName.CONFIRM_ENROLMENT_EARLY, ApplicationActionName.UNDO_CONFIRM_ENROLMENT, ApplicationActionName.UNDO_CONFIRM_ENROLMENT_EARLY, ApplicationActionName.START_DEFERRAL, ApplicationActionName.FINISH_DEFERRAL, ApplicationActionName.CANCEL_DEFERRAL, ApplicationActionName.START_REFUND, ApplicationActionName.FINISH_REFUND, ApplicationActionName.CANCEL_REFUND, ApplicationActionName.RESTART_EVALUATION, ApplicationActionName.RESTART_SUBMISSION, ApplicationActionName.RESTART_ADMISSION, ApplicationActionName.RESTART_DECISION, ApplicationActionName.RESTART_VISA_STEPS, ApplicationActionName.WITHDRAW, ApplicationActionName.EDIT_WITHDRAW_REASON, ApplicationActionName.UNDO_WITHDRAW, ApplicationActionName.EDIT_CANCEL_REASON, ApplicationActionName.UNDO_CANCEL];
var validSelfServeActions = [ApplicationActionName.CHANGE_INTAKE, ApplicationActionName.CHANGE_PROGRAM, ApplicationActionName.RECOMMENDED_PROGRAM, ApplicationActionName.REQUEST_DEFERRAL, ApplicationActionName.REQUEST_TUITION_DEPOSIT_REFUND, ApplicationActionName.FINISH_DEFERRAL, ApplicationActionName.CANCEL_DEFERRAL, ApplicationActionName.CANCEL];
export function ManageApplicationButton(_ref) {
  var emphasis = _ref.emphasis;
  var buttonRef = useRef(null);
  var compactButtonRef = useRef(null);
  var _useManageApplication = useManageApplicationEventTracker(),
    trackEvent = _useManageApplication.trackEvent;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useLegacyHandlers = useLegacyHandlers(application.id),
    handleChangeIntakeSuccess = _useLegacyHandlers.handleChangeIntakeSuccess,
    handleProcessDeferralSuccess = _useLegacyHandlers.handleProcessDeferralSuccess,
    handleDismissProcessDeferralSuccess = _useLegacyHandlers.handleDismissProcessDeferralSuccess,
    handleChangeProgramSuccess = _useLegacyHandlers.handleChangeProgramSuccess,
    handleStatusUpdateSuccess = _useLegacyHandlers.handleStatusUpdateSuccess,
    handleSelfServeUpdateSuccess = _useLegacyHandlers.handleSelfServeUpdateSuccess;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAction = _useState2[0],
    setSelectedAction = _useState2[1];
  var closeDialog = function closeDialog() {
    var _buttonRef$current;
    flushSync(function () {
      setSelectedAction(null);
    });
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
  };
  var program = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var programEsl = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var history = useHistory();
  var _useFeatureFlags = useFeatureFlags(),
    featureFlags = _useFeatureFlags.featureFlags;
  return _jsxs(_Fragment, {
    children: [_jsx(Box, {
      hideBelow: "sm",
      children: _jsx(ManageApplicationButtonMenu, {
        buttonRef: buttonRef,
        emphasis: emphasis,
        onSelectAction: setSelectedAction
      })
    }), _jsx(Box, {
      hideAbove: "sm",
      children: _jsx(ManageApplicationButtonMenu, {
        buttonRef: compactButtonRef,
        emphasis: emphasis,
        variant: "compact",
        onSelectAction: setSelectedAction
      })
    }), _jsx(ChangeIntakeModal, {
      hideDialogTrigger: true,
      isOpenViaProp: selectedAction === ApplicationActionName.CHANGE_INTAKE,
      origin: "self serve",
      onOpenChange: closeDialog,
      onSuccess: handleChangeIntakeSuccess
    }), _jsx(RecommendedProgramsDialog, {
      triggerSettings: {
        hide: true
      },
      isOpen: selectedAction === ApplicationActionName.RECOMMENDED_PROGRAM,
      onOpenChange: closeDialog,
      origin: "self-serve",
      school: {
        id: legacyApplication.school.id,
        country: legacyApplication.school.countryCode
      },
      program: {
        id: program === null || program === void 0 ? void 0 : program.programId,
        level: program === null || program === void 0 ? void 0 : program.levelText
      },
      academicIntake: program === null || program === void 0 ? void 0 : program.intake.startDate,
      eslIntake: programEsl === null || programEsl === void 0 ? void 0 : programEsl.intake.startDate
    }), _jsx(RequestDeferralDialog, {
      isOpen: selectedAction === ApplicationActionName.REQUEST_DEFERRAL,
      onOpenChange: closeDialog,
      onSuccess: function onSuccess() {
        trackEvent({
          event: 'Request a Deferral - Clicked Submit'
        });
      }
    }), _jsx(RequestTuitionDepositRefundDialog, {
      isOpen: selectedAction === ApplicationActionName.REQUEST_TUITION_DEPOSIT_REFUND,
      onOpenChange: closeDialog,
      onSuccess: function onSuccess() {
        trackEvent({
          event: 'Request a Tuition Refund - Clicked Submit'
        });
      }
    }), _jsx(ProcessDeferralModal, {
      isOpen: selectedAction === ApplicationActionName.FINISH_DEFERRAL || selectedAction === ApplicationActionName.CANCEL_DEFERRAL,
      onOpenChange: closeDialog,
      deferralAction: selectedAction === ApplicationActionName.FINISH_DEFERRAL || selectedAction === ApplicationActionName.CANCEL_DEFERRAL ? selectedAction : null,
      onSuccess: handleProcessDeferralSuccess,
      onDismissSuccess: function onDismissSuccess() {
        return handleDismissProcessDeferralSuccess({
          applicationId: application.legacyId,
          history: history,
          isMarkdownRendererEnabled: !!featureFlags['application_apr_notes']
        });
      }
    }), _jsx(ChangeProgramModal, {
      isOpen: selectedAction === ApplicationActionName.CHANGE_PROGRAM,
      onOpenChange: closeDialog,
      onSuccess: handleChangeProgramSuccess
    }), _jsx(SimpleStatusActionDialog, {
      actionId: selectedAction,
      onClose: closeDialog,
      onSuccess: function onSuccess() {
        closeDialog();
        handleStatusUpdateSuccess({
          applicationId: application.legacyId,
          history: history,
          isMarkdownRendererEnabled: !!featureFlags['application_apr_notes']
        });
      }
    }), _jsx(CancelWithdrawActionDialog, {
      actionId: selectedAction,
      onClose: closeDialog,
      onSuccess: function onSuccess() {
        var showNoteDialog = selectedAction === ApplicationActionName.CANCEL || selectedAction === ApplicationActionName.WITHDRAW;
        closeDialog();
        if (showNoteDialog) {
          handleSelfServeUpdateSuccess({
            applicationId: application.legacyId,
            history: history,
            isMarkdownRendererEnabled: !!featureFlags['application_apr_notes']
          });
        }
      }
    }), _jsx(CompleteAdmissionActionDialog, {
      isOpen: selectedAction === ApplicationActionName.COMPLETE_ADMISSION,
      onClose: closeDialog,
      onSuccess: function onSuccess() {
        closeDialog();
        handleStatusUpdateSuccess({
          applicationId: application.legacyId,
          history: history,
          isMarkdownRendererEnabled: !!featureFlags['application_apr_notes']
        });
      }
    })]
  });
}
function ManageApplicationButtonMenu(_ref2) {
  var buttonRef = _ref2.buttonRef,
    emphasis = _ref2.emphasis,
    variant = _ref2.variant,
    onSelectAction = _ref2.onSelectAction;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMenuOpen = _useState4[0],
    setIsMenuOpen = _useState4[1];
  var _useTranslation = useTranslation('ManageApplicationButton'),
    t = _useTranslation.t;
  var _useManageApplication2 = useManageApplicationEventTracker(),
    trackEvent = _useManageApplication2.trackEvent;
  var _useManageApplication3 = useManageApplicationMenuButtonActions(),
    selfServeActions = _useManageApplication3.selfServeActions,
    statusActions = _useManageApplication3.statusActions;
  if (selfServeActions.length === 0 && statusActions.length === 0) return _jsx(_Fragment, {});
  var showLabels = selfServeActions.length > 0 && statusActions.length > 0;
  return _jsxs(MenuButton, {
    open: isMenuOpen,
    onOpenChange: setIsMenuOpen,
    alignment: "right",
    children: [_jsx(MenuButton.Trigger, {
      children: variant === 'compact' ? _jsx(Button, {
        ref: buttonRef,
        intent: "primary",
        emphasis: emphasis || 'contained',
        "aria-label": t('trigger'),
        leadIcon: EditOutlineIcon,
        trailIcon: ChevronDownOutlineIcon,
        onClick: function onClick() {
          return setIsMenuOpen(true);
        }
      }) : _jsx(Button, {
        ref: buttonRef,
        intent: "primary",
        emphasis: emphasis || 'contained',
        leadIcon: EditOutlineIcon,
        trailIcon: ChevronDownOutlineIcon,
        onClick: function onClick() {
          return setIsMenuOpen(true);
        },
        children: t('trigger')
      })
    }), showLabels && _jsx(MenuButton.Label, {
      children: t('statusUpdates')
    }), statusActions.map(function (action) {
      return _jsx(MenuButton.Button, {
        id: action.id,
        onClick: function onClick() {
          onSelectAction(action.id);
          trackEvent({
            event: "Clicked ".concat(action.displayName)
          });
        },
        children: action.displayName
      }, action.id);
    }), showLabels && _jsx(MenuButton.Label, {
      children: t('selfServe')
    }), selfServeActions.map(function (action) {
      return _jsx(MenuButton.Button, {
        id: action.id,
        onClick: function onClick() {
          onSelectAction(action.id);
          trackEvent({
            event: "Clicked ".concat(action.displayName)
          });
        },
        children: action.displayName
      }, action.id);
    })]
  });
}
function SimpleStatusActionDialog(_ref3) {
  var actionId = _ref3.actionId,
    onClose = _ref3.onClose,
    _onSuccess = _ref3.onSuccess;
  var _useTranslation2 = useTranslation('ManageApplicationButton'),
    t = _useTranslation2.t;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    applicationAvailableActions = _useApplicationAvaila.applicationAvailableActions;
  var _useSendApplicationAc = useSendApplicationAction(),
    sendApplicationAction = _useSendApplicationAc.sendApplicationAction,
    sendApplicationStatus = _useSendApplicationAc.sendApplicationStatus;
  var toasts = useToasts();
  var statusAction = SimpleStatusApplicationAction.safeParse({
    actionId: actionId
  }).data;
  var selectedAction = applicationAvailableActions.find(function (action) {
    return action.id === actionId;
  });
  if (!statusAction || !selectedAction) {
    return null;
  }
  return _jsxs(Dialog, {
    open: !!statusAction,
    onOpenChange: function onOpenChange(newOpen) {
      if (!newOpen) {
        onClose();
      }
    },
    children: [_jsx(Dialog.Heading, {
      children: t('statusUpdateDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(Markdown, {
        headingSettings: {
          baseLevel: 3
        },
        markdown: t('statusUpdateDialog.content', {
          statusUpdate: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.displayName
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('statusUpdateDialog.cancelButton')
      }), _jsx(Button, {
        intent: "primary",
        emphasis: "contained",
        width: "fill",
        loading: sendApplicationStatus === 'loading',
        onClick: function onClick() {
          sendApplicationAction(statusAction, {
            onSuccess: function onSuccess() {
              toasts.positive(t('statusUpdateDialog.success'));
              _onSuccess();
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              }
            }
          });
        },
        children: t('statusUpdateDialog.confirmButton')
      })]
    })]
  });
}
function CompleteAdmissionActionDialog(_ref4) {
  var isOpen = _ref4.isOpen,
    onClose = _ref4.onClose,
    _onSuccess2 = _ref4.onSuccess;
  var _useTranslation3 = useTranslation('ManageApplicationButton'),
    t = _useTranslation3.t;
  var _useSendApplicationAc2 = useSendApplicationAction(),
    sendApplicationAction = _useSendApplicationAc2.sendApplicationAction,
    sendApplicationStatus = _useSendApplicationAc2.sendApplicationStatus;
  var _useIntakes = useIntakes(),
    academicIntakes = _useIntakes.academicIntakes,
    eslIntakes = _useIntakes.eslIntakes;
  var _useApplicationAvaila2 = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila2.getApplicationAvailableAction;
  var _useApplicationMainPr = useApplicationMainProgram(),
    academicProgram = _useApplicationMainPr.mainProgram;
  var _useApplicationEslPro = useApplicationEslProgram(),
    eslProgram = _useApplicationEslPro.eslProgram;
  var toasts = useToasts();
  var completeAdmissionAction = getApplicationAvailableAction(ApplicationActionName.COMPLETE_ADMISSION);
  if (!isOpen || !completeAdmissionAction) {
    return null;
  }
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(newOpen) {
      if (!newOpen) {
        onClose();
      }
    },
    children: [_jsx(Dialog.Heading, {
      children: t('statusUpdateDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(Markdown, {
          headingSettings: {
            baseLevel: 3
          },
          markdown: t('statusUpdateDialog.completeAdmissionContent', {
            statusUpdate: completeAdmissionAction === null || completeAdmissionAction === void 0 ? void 0 : completeAdmissionAction.displayName
          })
        }), _jsx(IntakesForm, {
          id: "completeAdmissionForm",
          availableActions: {
            canUpdateEsl: true,
            canUpdateStartDates: true
          },
          academicIntakes: academicIntakes,
          eslIntakes: eslIntakes,
          onSubmit: function onSubmit(values) {
            var selectedEslIntake = eslIntakes.find(function (intake) {
              return intake.startDate === values.eslIntake;
            });
            var selectedAcademicIntake = academicIntakes.find(function (intake) {
              return intake.startDate === values.academicIntake;
            });
            assert(selectedAcademicIntake, "Cannot find academic intake with start date ".concat(values.academicIntake));
            if (values.eslIntake) {
              assert(selectedEslIntake, "Cannot find ESL intake with start date ".concat(values.eslIntake));
            }
            sendApplicationAction({
              actionId: ApplicationActionName.COMPLETE_ADMISSION,
              actionData: {
                programs: [{
                  legacyIntakeId: Number(selectedAcademicIntake.intakeId),
                  legacyProgramId: Number(academicProgram.id),
                  actualStartDate: values.academicActualStartDate,
                  alternateActualStartDate: values.academicAlternateActualStartDate || undefined
                }].concat(_toConsumableArray(values.eslIntake && eslProgram && selectedEslIntake ? [{
                  legacyIntakeId: Number(selectedEslIntake.intakeId),
                  legacyProgramId: Number(eslProgram.id),
                  actualStartDate: values.eslActualStartDate,
                  alternateActualStartDate: values.eslAlternateActualStartDate
                }] : []))
              }
            }, {
              onSuccess: function onSuccess() {
                toasts.positive(t('statusUpdateDialog.success'));
                _onSuccess2();
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                }
              }
            });
          },
          academicIntakeVariant: "select"
        })]
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('statusUpdateDialog.cancelButton')
      }), _jsx(Button, {
        type: "submit",
        form: "completeAdmissionForm",
        intent: "primary",
        emphasis: "contained",
        width: "fill",
        loading: sendApplicationStatus === 'loading',
        children: t('statusUpdateDialog.confirmButton')
      })]
    })]
  });
}
function useManageApplicationMenuButtonActions() {
  var _useApplicationAvaila3 = useApplicationAvailableActions(),
    applicationAvailableActions = _useApplicationAvaila3.applicationAvailableActions;
  var _useFeatureFlags2 = useFeatureFlags(),
    featureFlags = _useFeatureFlags2.featureFlags;
  var showStatusActions = featureFlags['application_apr_ats'];
  var filterMenuActions = function filterMenuActions(validActions) {
    var filteredActions = applicationAvailableActions.filter(function (action) {
      return validActions.includes(action.id);
    });
    return sortBy(filteredActions, function (action) {
      return validActions.indexOf(action.id);
    });
  };
  return {
    statusActions: showStatusActions ? filterMenuActions(validStatusActions) : [],
    selfServeActions: showStatusActions ? filterMenuActions(validSelfServeActions).filter(function (action) {
      return action.id !== ApplicationActionName.FINISH_DEFERRAL && action.id !== ApplicationActionName.CANCEL_DEFERRAL;
    }) : filterMenuActions(validSelfServeActions)
  };
}